import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import calendarIcon from "images/phase-3/materialitySurvey/calender.png";
import barChartIcon from "images/phase-3/materialitySurvey/BarChartIcon.png";
import stirrupLogo from "images/phase-3/stirrup_logo/stirrup-logo.svg";

const VARIANT_CONFIG = {
  not_available: {
    title: "This Survey is not yet available",
    subtitle: "Please check back later when the survey becomes available",
    icon: calendarIcon,
  },
  ended: {
    title: "The Survey has Ended",
    subtitle: "Please get in touch with your support to participate",
    icon: barChartIcon,
  },
  submitted: {
    title: "Survey response has been submitted",
    subtitle: "Thank you for the responses",
    icon: null,
  },
};

const NoSurveyDataComponent = ({
  variant = "not_available", // not_available | ended | submitted
  dateText,
  image,
}) => {
  const config = VARIANT_CONFIG[variant];

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* Header with Logo */}
      <Box
        sx={{
          background: "#fff",
          p: 2,
          width: "90%",
          margin: "auto",
        }}
      >
        <Box
          component="img"
          src={stirrupLogo}
          alt="Stirrup Logo"
          sx={{
            width: "150px",
            height: "auto",
          }}
        />
      </Box>

      {/* Content */}
      <Box
        sx={{
          flex: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          textAlign: "center",
          p: 4,
        }}
      >
        {/* Illustration */}
        <Box
          component="img"
          src={image}
          alt="survey-state"
          sx={{ width: 280, mb: 3 }}
        />

        {/* Title */}
        <Typography variant="h2" fontWeight={600} gutterBottom>
          {config.title}
        </Typography>

        {/* Subtitle */}
        <Typography variant="caption" color="text.secondary" mb={2}>
          {config.subtitle}
        </Typography>

        {/* Date Box (optional) */}
        {dateText && (
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              bgcolor: "#EBF1F8",
              px: 2,
              py: 1,
              borderRadius: 2,
            }}
          >
            {config.icon && (
              <Box
                component="img"
                src={config.icon}
                alt="icon"
                sx={{ width: 25, height: 25 }}
              />
            )}
            <Stack
              display={"flex"}
              direction={"column"}
              gap={1}
              alignItems="flex-start"
            >
              {variant === "not_available" ? (
                <Typography
                  variant="caption"
                  fontWeight={400}
                  sx={{ color: "#15314E" }}
                >
                  The survey will be available on
                </Typography>
              ) : (
                <Typography
                  variant="caption"
                  fontWeight={400}
                  sx={{ color: "#15314E" }}
                >
                  `This survey ended on {dateText}`
                </Typography>
              )}

              <Typography
                variant="body1"
                fontWeight={500}
                sx={{ color: "#3374B9" }}
              >
                {dateText}
              </Typography>
            </Stack>
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default NoSurveyDataComponent;
